namespace RioERP.Products {
    export interface ProductsFranchiseeForm {
        RowIds: Serenity.StringEditor;
        FranchiseeId: Serenity.LookupEditor;
        ESharingType: Serenity.EnumEditor;
        SharingAmount: Serenity.DecimalEditor;
    }

    export class ProductsFranchiseeForm extends Serenity.PrefixedContext {
        static formKey = 'RioERP.ProductsFranchiseeForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductsFranchiseeForm.init)  {
                ProductsFranchiseeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.EnumEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(ProductsFranchiseeForm, [
                    'RowIds', w0,
                    'FranchiseeId', w1,
                    'ESharingType', w2,
                    'SharingAmount', w3
                ]);
            }
        }
    }
}
